// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import useAuth from './hooks/useAuth';
import NotistackProvider from './components/NotistackProvider';
import { RootState, useDispatch, useSelector } from './redux/store';
import { loadWorkspace } from './redux/slices/workspace';
import GoogleAnalytics from './components/GoogleAnalytics';
import { RecoilRoot } from 'recoil';
import React from 'react';
import LanguageDetector from 'theme/LanguageDetector';

class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    console.log('error', error);
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.log('error', error);
    console.log('errorInfo', errorInfo);
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    // if (this.state?.hasError) {
    //   // You can render any custom fallback UI
    //   return <h1>Something went wrong.</h1>;
    // }

    return this.props.children;
  }
}

// ----------------------------------------------------------------------
export default function App() {
  const { loaded } = useSelector((state: RootState) => state.workspace);
  const applicationDispatch = useDispatch();
  if (!loaded) {
    applicationDispatch(loadWorkspace());
  }
  const { isInitialized } = useAuth();
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <RtlLayout>
          <NotistackProvider>
            <RecoilRoot>
              <ErrorBoundary>
                <React.Suspense fallback={<LoadingScreen />}>
                  <GlobalStyles />
                  <ProgressBarStyle />
                  <ScrollToTop />
                  <GoogleAnalytics />
                  <LanguageDetector />
                  {isInitialized ? <Router /> : <LoadingScreen />}
                </React.Suspense>
              </ErrorBoundary>
            </RecoilRoot>
          </NotistackProvider>
        </RtlLayout>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
